/*!
 * Copyright © 2022-2023. Verizon Connect Ireland Limited. All rights reserved.
 */

import { Action } from '@ngrx/store';
import { IDeviceHealthCheckHistory } from '../../../device-health-check/models';
import { IDeviceCommandResponse, IScrollItem, IVehicleWithBoxResponse, IVehicleWithEsnResponse } from '../../models';

export enum EDeviceHealthCheckActions {
  GetSelectedStatusItemId = '[DeviceHealthCheck] Get Selected Status Item Id',
  GetVehicleSpecification = '[DeviceHealthCheck] Get Vehicle Specification',
  GetVehicleSpecificationSuccess = '[DeviceHealthCheck] Get Vehicle Specification Success',
  GetVehicleWithEsn = '[DeviceHealthCheck] Get Vehicle With Esn',
  GetVehicleWithEsnSuccess = '[DeviceHealthCheck] Get Vehicle With Esn Success',
  SetSidePanelSelectedItem = '[DeviceHealthCheck] Set Side Panel Selected Item',
  StopDeviceHealthCheckPolling = '[DeviceHealthCheck] Stop Device Health Check Polling',

  SendPing = '[DeviceHealthCheck] Send Ping',
  SendPingSuccess = '[DeviceHealthCheck] Send Ping Success',
  SendPingFailure = '[DeviceHealthCheck] Send Ping Failure',
  PingResponsePending = '[DeviceHealthCheck] Ping Response Pending',
  PingResponseSuccess = '[DeviceHealthCheck] Ping Response Success',
  PingResponseFailure = '[DeviceHealthCheck] Ping ResponsFailure',

  SendReset = '[DeviceHealthCheck] Send Reset',
  SendResetSuccess = '[DeviceHealthCheck] Send Reset Success',
  SendResetFailure = '[DeviceHealthCheck] Send Reset Failure',
  ResetResponsePending = '[DeviceHealthCheck] Reset Response Pending',
  ResetResponseSuccess = '[DeviceHealthCheck] Reset Response Success',
  ResetResponseFailure = '[DeviceHealthCheck] Reset ResponsFailure',

  GetHistory = '[DeviceHealthCheck] Get History',
  GetHistorySuccess = '[DeviceHealthCheck] Get History Success'
}

export class GetSelectedStatusItemId implements Action {
  public readonly type = EDeviceHealthCheckActions.GetSelectedStatusItemId;

  constructor(public payload: number) {}
}

export class GetVehicleSpecification implements Action {
  public readonly type = EDeviceHealthCheckActions.GetVehicleSpecification;

  constructor(public payload: number) {}
}

export class GetVehicleSpecificationSuccess implements Action {
  public readonly type = EDeviceHealthCheckActions.GetVehicleSpecificationSuccess;

  constructor(public payload: IVehicleWithBoxResponse) {}
}

export class GetVehicleWithEsn implements Action {
  public readonly type = EDeviceHealthCheckActions.GetVehicleWithEsn;

  constructor(public payload: number) {}
}

export class GetVehicleWithEsnSuccess implements Action {
  public readonly type = EDeviceHealthCheckActions.GetVehicleWithEsnSuccess;

  constructor(public payload: IVehicleWithEsnResponse) {}
}

export class SetSidePanelSelectedItem implements Action {
  public readonly type = EDeviceHealthCheckActions.SetSidePanelSelectedItem;

  constructor(public payload: IScrollItem) {}
}

export class StopDeviceHealthCheckPolling implements Action {
  public readonly type = EDeviceHealthCheckActions.StopDeviceHealthCheckPolling;
}

export class SendPing implements Action {
  public readonly type = EDeviceHealthCheckActions.SendPing;

  constructor(public payload: string) {}
}

export class SendPingSuccess implements Action {
  public readonly type = EDeviceHealthCheckActions.SendPingSuccess;

  constructor(public payload: IDeviceCommandResponse) {}
}

export class SendPingFailure implements Action {
  public readonly type = EDeviceHealthCheckActions.SendPingFailure;
}

export class PingResponsePending implements Action {
  public readonly type = EDeviceHealthCheckActions.PingResponsePending;
}

export class PingResponseSuccess implements Action {
  public readonly type = EDeviceHealthCheckActions.PingResponseSuccess;
}

export class PingResponseFailure implements Action {
  public readonly type = EDeviceHealthCheckActions.PingResponseFailure;
}

export class SendReset implements Action {
  public readonly type = EDeviceHealthCheckActions.SendReset;
}

export class SendResetSuccess implements Action {
  public readonly type = EDeviceHealthCheckActions.SendResetSuccess;

  constructor(public payload: IDeviceCommandResponse) {}
}

export class SendResetFailure implements Action {
  public readonly type = EDeviceHealthCheckActions.SendResetFailure;
}

export class ResetResponsePending implements Action {
  public readonly type = EDeviceHealthCheckActions.ResetResponsePending;
}

export class ResetResponseSuccess implements Action {
  public readonly type = EDeviceHealthCheckActions.ResetResponseSuccess;
}

export class ResetResponseFailure implements Action {
  public readonly type = EDeviceHealthCheckActions.ResetResponseFailure;
}

export class GetHistory implements Action {
  public readonly type = EDeviceHealthCheckActions.GetHistory;
}

export class GetHistorySuccess implements Action {
  public readonly type = EDeviceHealthCheckActions.GetHistorySuccess;

  constructor(public payload: IDeviceHealthCheckHistory[]) {}
}

export type DeviceHealthCheckActions =
  | GetSelectedStatusItemId
  | GetVehicleSpecification
  | GetVehicleSpecificationSuccess
  | GetVehicleWithEsn
  | GetVehicleWithEsnSuccess
  | SetSidePanelSelectedItem
  | StopDeviceHealthCheckPolling
  | SendPing
  | SendPingSuccess
  | SendPingFailure
  | PingResponsePending
  | PingResponseSuccess
  | PingResponseFailure
  | SendReset
  | SendResetSuccess
  | SendResetFailure
  | ResetResponsePending
  | ResetResponseSuccess
  | ResetResponseFailure
  | GetHistory
  | GetHistorySuccess;
